import { ErrorHandler, Injectable, signal } from '@angular/core';

// Signal accesible desde cualquier componente sin necesidad de inyección
export const globalErrorMsg = signal('');

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const msg = error instanceof Error ? error.message : String(error);
    // Ignorar errores de lazy-loading (chunk load failures son normales en navegación)
    if (msg.includes('ChunkLoad') || msg.includes('Loading chunk')) return;
    console.error('[AdminPanel Error]', error);
    globalErrorMsg.set(msg.slice(0, 180));
    setTimeout(() => globalErrorMsg.set(''), 6000);
  }
}
